/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "11.0.0";
